import desHelper from '@/commom/epct/DesHelper.js';

///本地用户信息
const localUser = {
    ///缓存用户信息
    cacheUser:function(user){
        var userStr = desHelper.encode(JSON.stringify(user))
        localStorage.setItem("_pscd",userStr)
    },
    ///清除本地缓存用户
    clearCacheUser:function(){
        localStorage.removeItem("_pscd")
    },
    ///获取本地缓存用户，失败返回null
    getLocalUser:function(){
        var userStr = localStorage.getItem("_pscd")
        if(userStr == null){
            return null
        }
        try{
            var user = JSON.parse(desHelper.decode(userStr))
            return user;
        }catch(e){
            return null
        }
    }
}

export default localUser